import "../assets/css/vendor-product-forms.css";
import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Alert,
} from "react-bootstrap";
import DiscountFields, { discountPayloadOf } from "../components/DiscountFields";
import { useProductFormGate } from "../components/team/Gated";
import HeadOfficeProductNote from "../components/branch/HeadOfficeProductNote";
import {
  MdAddAPhoto,
  MdWarning,
  MdCrop,
  MdCropSquare,
  MdCropLandscape,
  MdAddCircle,
  MdAutoFixHigh,
  MdUndo,
} from "react-icons/md";
import { Switch, FormControlLabel } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import { uploadImageToCloudinary as sharedUpload } from "../utilities/imageUpload";
import { toast } from "react-toastify";
import Select from "../components/ui/AppReactSelect";
import { createRestaurantMenuProduct } from "../actions/restaurantProductsAction";
import { fetchSections } from "../actions/sectionAction.js";
import { useWorkingRestaurant, WorkingRestaurantField } from "./Components/WorkingRestaurant";
import { fetchOptionGroupsRestaurant } from "../actions/optionAction.js";
import { getUserFromLocalStorage } from "utilities/user";
// import OptionGroupForm from './OptionsGroupForm';
import OptionGroupModal from "../components/Restaurant/OptionGroupModal";
import ReactCrop from "react-image-crop";
import { centerCrop, makeAspectCrop } from "react-image-crop";
import { IconButton, Tooltip } from "@material-ui/core";
import MobileProductShootPicker from "../components/MobileProductShootPicker";
import AdditionalImagesStrip from "../components/AdditionalImagesStrip";
import ProductVideoSection from "../components/ProductVideoSection";
import ArtworkTemplateLink from "../components/ArtworkTemplateLink";
import UploadProgress from "../components/UploadProgress";
import { productPhotoHint } from "../utilities/productPhotoRules";
import AppSelect from "../components/ui/AppSelect";
import { vendorOwnerIdOf } from "../utilities/vendorScope";

const useStyles = makeStyles((theme) => ({
  label: {
    fontWeight: "normal",
    fontSize: "12px",
    textTransform: "capitalize",
  },
}));

const adornedStyles = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.create-product-card-adorned {
  animation: fadeIn 0.5s ease-out;
  border: none !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.create-product-header-adorned {
  background: linear-gradient(135deg, #17385aff 0%, #0a578bff 100%) !important;
  color: white !important;
  padding: 32px !important;
  border: none !important;
  border-radius: 16px 16px 0 0 !important;
}

.create-product-body-adorned {
  padding: 32px !important;
  background: white;
}

.form-section-adorned {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.form-section-adorned:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.form-label-adorned {
  font-weight: 600 !important;
  color: #17385aff !important;
  font-size: 14px !important;
  margin-bottom: 8px !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-adorned {
  border: 2px solid #e9ecef !important;
  border-radius: 8px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.form-control-adorned:focus {
  border-color: #17385aff !important;
  box-shadow: 0 0 0 0.2rem rgba(23, 56, 90, 0.15) !important;
}

.btn-adorned-primary {
  background: #17385aff !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
  box-shadow: 0 4px 12px rgba(23, 56, 90, 0.3) !important;
}

.btn-adorned-primary:hover {
  background: #0a578bff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(23, 56, 90, 0.4) !important;
}

.btn-adorned-secondary {
  background: #6c757d !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.btn-adorned-secondary:hover {
  background: #5a6268 !important;
  transform: translateY(-2px);
}

.btn-adorned-success {
  background: #28a745 !important;
  border: none !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 10px 24px !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-family: 'Inter', sans-serif !important;
}

.btn-adorned-success:hover {
  background: #218838 !important;
  transform: translateY(-2px);
}

.image-upload-card-adorned {
  border: 2px dashed #17385aff !important;
  border-radius: 12px !important;
  background: #f8f9fa !important;
  transition: all 0.3s ease !important;
}

.image-upload-card-adorned:hover {
  border-color: #0a578bff !important;
  background: #e9ecef !important;
}

.modal-adorned .modal-content {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important;
}

.modal-adorned .modal-header {
  background: linear-gradient(135deg, #17385aff 0%, #0a578bff 100%) !important;
  color: white !important;
  border-radius: 16px 16px 0 0 !important;
  padding: 24px !important;
  border: none !important;
}

.modal-adorned .modal-header .btn-close {
  filter: brightness(0) invert(1);
}

.modal-adorned .modal-title {
  font-weight: 700 !important;
  font-family: 'Inter', sans-serif !important;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
`;

const CreateRestaurantProductForm = () => {
  const user = getUserFromLocalStorage();
  const vendorId = vendorOwnerIdOf(user);
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const sections = useSelector((state) => state.sections.sections);
  const optionGroups = useSelector((state) => state.options.optionGroups);

  const isMounted = useRef(true);

  // The restaurant whose menu this dish is for. Opened from a restaurant's
  // menu drawer it arrives in the route state; a vendor on their own menu is
  // the owner. It is shown on the form, never chosen (WorkingRestaurant.js).
  const workingRef = location.state?.restaurantId || vendorId;
  const { restaurant: workingRestaurant, loading: workingRestaurantLoading } =
    useWorkingRestaurant(workingRef, location.state?.restaurantHint || null);
  // Options, option groups and the phone-shoot picker are keyed by the OWNER.
  const ownerId = workingRestaurant?.ownerId || vendorId;

  useEffect(() => {
    dispatch(fetchSections(workingRef));
    return () => {
      isMounted.current = false;
    };
  }, [dispatch, workingRef]);

  useEffect(() => {
    if (ownerId) dispatch(fetchOptionGroupsRestaurant(ownerId));
  }, [dispatch, ownerId]);

  const initialSection = location.state?.sectionId || "";

  // Back to the menu the form was opened from: a restaurant's menu drawer
  // (staff) returns there, a vendor's own menu page stays the default.
  const leaveForm = () => {
    if (location.state?.restaurantId) history.goBack();
    else history.push("/admin/rest-menu");
  };

  const [product, setProduct] = useState({
    name: "",
    description: "",
    section: initialSection,
    restaurant: workingRef || "",
    price: 0.0,
    countInStock: 0,
    dailyLimit: "",
    image: null,
    /* Optional extra angles — see AdditionalImagesStrip for details. */
    additionalImages: [],
    /* Product videos — frozen contract entries, see ProductVideoSection. */
    videos: [],
    // Deactivated until QC activates it (see the model default).
    enabled: false,
    optionGroups: [],
    requiredPaymentMethod: "NONE",
    discount: null,
    tags: [],
  });

  const [priceWarning, setPriceWarning] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadError, setUploadError] = useState(null);
  const [isFormatCorrect, setIsFormatCorrect] = useState(false);
  const [isSizeCorrect, setIsSizeCorrect] = useState(false);
  const [isResolutionCorrect, setIsResolutionCorrect] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const gate = useProductFormGate(submitting || uploading);

  const [selectedOptionGroups, setSelectedOptionGroups] = useState([]);
  const [showOptionGroupModal, setShowOptionGroupModal] = useState(false);
  // null = the modal creates; a populated group = it edits that group.
  const [editingGroup, setEditingGroup] = useState(null);

  const selectedRestaurant = workingRestaurant;
  const previewCommissionRate = Number(selectedRestaurant?.commissionRate ?? 8);
  const previewGrossPrice = Number(product.price) || 0;
  const previewCommission = Math.round(previewGrossPrice * previewCommissionRate) / 100;
  const previewVendorNet = previewGrossPrice - previewCommission;

  const [currentImage, setCurrentImage] = useState(null);
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);

  const [aspect, setAspect] = useState(1);
  const [crop, setCrop] = useState({
    unit: "%",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
  });
  const [completedCrop, setCompletedCrop] = useState(null);

  // Background removal state
  const [removingBackground, setRemovingBackground] = useState(false);
  const [originalImage, setOriginalImage] = useState(null);
  const [backgroundRemoved, setBackgroundRemoved] = useState(false);

  const ASPECT_RATIO = 1; // For 1:1 square crop
  const MIN_DIMENSION = 1000; // Minimum dimension requirement
  const PREVIEW_CONTAINER_SIZE = 300; // Preview container size

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "price") {
      if (parseFloat(value) < 0) {
        setPriceWarning("Please enter a Price higher than 0.");
        setProduct((prev) => ({ ...prev, [name]: "" }));
        return;
      } else {
        setPriceWarning("");
      }
    }

    if (name === "countInStock" && value < 1) {
      toast.error("Count in Stock cannot be less than 1");
      return;
    }

    setProduct({ ...product, [name]: value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setUploadError("No file was selected.");
      toast.error("No file was selected.");
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        if (!isMounted.current) return;

        setImagePreview(reader.result);
        setProduct((prev) => ({ ...prev, image: reader.result }));
        setShowPreviewModal(true);

        const validFormats = ["image/jpeg", "image/png"];
        const isCurrentFormatCorrect = validFormats.includes(file.type);
        const isCurrentSizeCorrect = file.size <= 10 * 1024 * 1024;
        const isCurrentResolutionCorrect =
          img.width >= 1000 && img.height >= 1000;

        setIsFormatCorrect(isCurrentFormatCorrect);
        setIsSizeCorrect(isCurrentSizeCorrect);
        setIsResolutionCorrect(isCurrentResolutionCorrect);

        if (
          !isCurrentFormatCorrect ||
          !isCurrentSizeCorrect ||
          !isCurrentResolutionCorrect
        ) {
          let errorMessage =
            "Please ensure the image meets all the requirements:";
          if (!isCurrentFormatCorrect)
            errorMessage += " Must be JPG or PNG format.";
          if (!isCurrentSizeCorrect)
            errorMessage += " Must be less than or equal to 10MB.";
          if (!isCurrentResolutionCorrect)
            errorMessage += " Must be at least 1000x1000 pixels.";
          setUploadError(errorMessage);
        } else {
          setUploadError(null);
        }
      };
      img.onerror = () => {
        if (!isMounted.current) return;

        setUploadError("There was an error processing your image.");
        setImagePreview(null);
        setShowPreviewModal(false);
        toast.error("There was an error processing your image.");
      };
      img.src = reader.result;
    };
    reader.onerror = () => {
      if (!isMounted.current) return;

      setUploadError("Failed to read the image file.");
      setImagePreview(null);
      setProduct((prev) => ({ ...prev, image: null }));
      setShowPreviewModal(false);
    };
    reader.readAsDataURL(file);
  };

  const uploadImageToCloudinary = async (file, assetPurpose = "product_cover") => {
    if (!file) {
      toast.error("No image file selected!");
      return null;
    }

    setUploading(true);
    try {
      const result = await sharedUpload(file, {
        skipValidation: true,
        vendorMedia: {
          vendorType: "restaurant",
          vendorId: product.restaurant || vendorId,
          assetPurpose,
          entityType: "restaurantProduct",
          entityId: product._id || product.name || "new-product",
          source: "dashboard",
        },
        onProgress: (percent) => {
          if (!isMounted.current) return;
          setUploadProgress(percent);
        },
      });
      const secureUrl = result.secure_url;
      if (!isMounted.current) return null;

      setProduct((prevProduct) => ({
        ...prevProduct,
        image: secureUrl,
      }));
      setUploading(false);
      setShowPreviewModal(false);
      return secureUrl;
    } catch (error) {
      if (!isMounted.current) return null;

      console.error("Error uploading the image:", error);
      toast.error(`Failed to upload image: ${error.message}`);
      setUploading(false);
      setShowPreviewModal(false);
      return null;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setUploading(true);
    setSubmitting(true);

    let uploadedImageUrl = product.image;
    if (
      uploadedImageUrl &&
      typeof uploadedImageUrl === "string" &&
      uploadedImageUrl.startsWith("data:")
    ) {
      uploadedImageUrl = await uploadImageToCloudinary(uploadedImageUrl);
      if (!uploadedImageUrl) {
        if (isMounted.current) {
          toast.error("Image upload failed, please try again.");
          setUploading(false);
          setSubmitting(false);
        }
        return;
      }
    } else if (!uploadedImageUrl) {
      if (isMounted.current) {
        toast.error("Please add an image to the product.");
        setUploading(false);
        setSubmitting(false);
      }
      return;
    }

    /* Resolve newly-picked extra angles through Cloudinary; pass through
       any already-stored https URLs unchanged. */
    let resolvedAdditional = [];
    const picked = Array.isArray(product.additionalImages)
      ? product.additionalImages
      : [];
    for (const entry of picked) {
      if (typeof entry !== "string" || !entry) continue;
      if (entry.startsWith("data:")) {
        // eslint-disable-next-line no-await-in-loop
        const url = await uploadImageToCloudinary(entry, "product_angle");
        if (!url) {
          if (isMounted.current) {
            toast.error("One of the extra angles failed to upload.");
            setUploading(false);
            setSubmitting(false);
          }
          return;
        }
        resolvedAdditional.push(url);
      } else {
        resolvedAdditional.push(entry);
      }
    }

    const restaurantProductData = {
      name: product.name,
      description: product.description,
      sectionId: product.section,
      restaurantId: product.restaurant,
      price: product.price,
      image: uploadedImageUrl,
      additionalImages: resolvedAdditional,
      /* Contract-shaped entries; ProductVideoSection uploads on pick, so
         these are ready to persist as-is. */
      videos: Array.isArray(product.videos) ? product.videos : [],
      countInStock: product.countInStock,
      // Sold out for the day: empty means no daily limit.
      dailyLimit: product.dailyLimit === "" ? null : product.dailyLimit,
      enabled: product.enabled,
      requiredPaymentMethod: product.requiredPaymentMethod,
      discount: discountPayloadOf(product.discount),
      optionGroups: selectedOptionGroups.map((group) => group.value),
      tags: product.tags && product.tags.length > 0 ? product.tags : [product.name],
    };

    // console.log('Submitting product data:', restaurantProductData);

    try {
      await dispatch(
        createRestaurantMenuProduct(restaurantProductData, vendorId)
      );
      if (isMounted.current) {
        setProduct({
          name: "",
          description: "",
          section: initialSection,
          restaurant: workingRef || "",
          price: 0.0,
          countInStock: 0,
          image: null,
          additionalImages: [],
          videos: [],
          enabled: false,
          optionGroups: [],
          requiredPaymentMethod: "NONE",
          discount: null,
        });
        leaveForm();
      }
    } catch (error) {
      if (isMounted.current) {
        toast.error("Failed to save product, please try again.");
        setSubmitting(false);
      }
    } finally {
      if (isMounted.current) {
        setUploading(false);
        setSubmitting(false);
      }
    }
  };

  const handleRemoveBackground = async () => {
    if (!product.image) {
      toast.error("Please upload an image first");
      return;
    }

    setRemovingBackground(true);

    try {
      // Save original image if not already saved
      if (!originalImage) {
        setOriginalImage(product.image);
      }

      // Convert base64 to blob
      const base64Response = await fetch(product.image);
      const blob = await base64Response.blob();

      // Create FormData
      const formData = new FormData();
      formData.append('image_file', blob);
      formData.append('size', 'auto');

      // Call Remove.bg API
      const response = await axios.post('https://api.remove.bg/v1.0/removebg', formData, {
        headers: {
          'X-Api-Key': process.env.REACT_APP_REMOVEBG_API_KEY,
        },
        responseType: 'blob',
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log('Background removal progress:', percentCompleted);
        }
      });

      // Convert blob response to base64
      const reader = new FileReader();
      reader.onloadend = () => {
        setProduct({ ...product, image: reader.result });
        setBackgroundRemoved(true);
        toast.success("Background removed successfully!");
      };
      reader.readAsDataURL(response.data);

    } catch (error) {
      console.error('Background removal error:', error);
      if (error.response?.status === 403) {
        toast.error("API key invalid. Please configure Remove.bg API key.");
      } else if (error.response?.status === 402) {
        toast.error("Insufficient credits. Please check your Remove.bg account.");
      } else {
        toast.error("Failed to remove background. Please try again.");
      }
    } finally {
      setRemovingBackground(false);
    }
  };

  const handleRestoreOriginal = () => {
    if (originalImage) {
      setProduct({ ...product, image: originalImage });
      setBackgroundRemoved(false);
      toast.info("Original image restored");
    }
  };

  const handleDiscardChanges = () => {
    setProduct({
      name: "",
      description: "",
      section: initialSection,
      restaurant: workingRef || "",
      price: 0.0,
      countInStock: 0,
      image: null,
      additionalImages: [],
      videos: [],
      enabled: false,
    });
    setShowConfirmModal(false);
    leaveForm();
  };

  const handleCloseDiscardModal = () => {
    setShowConfirmModal(false);
  };

  const groupLabel = (g) =>
    `${g.name} (Min: ${g.minOptions}, Max: ${g.maxOptions})`;
  /* A created group is attached to the dish at once; an edited one has its
     chip relabelled so the rule it shows is current. */
  const handleOptionGroupSave = (saved) => {
    if (!saved?._id) return;
    setSelectedOptionGroups((prev) => {
      const chip = { value: saved._id, label: groupLabel(saved) };
      return prev.some((g) => String(g.value) === String(saved._id))
        ? prev.map((g) => (String(g.value) === String(saved._id) ? chip : g))
        : [...prev, chip];
    });
  };
  const openCreateGroup = () => {
    setEditingGroup(null);
    setShowOptionGroupModal(true);
  };
  const openEditGroup = (groupId) => {
    const found = (optionGroups || []).find((g) => String(g._id) === String(groupId));
    if (!found) return;
    setEditingGroup(found);
    setShowOptionGroupModal(true);
  };
  const closeOptionGroupModal = () => {
    setShowOptionGroupModal(false);
    setEditingGroup(null);
  };

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
          height: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }

  const handleImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    let initialCrop;

    if (aspect) {
      initialCrop = centerAspectCrop(width, height, aspect);
    } else {
      initialCrop = {
        unit: "%",
        x: 10,
        y: 10,
        width: 80,
        height: 80,
      };
    }

    setCrop(initialCrop);
    setCompletedCrop(initialCrop);
  };

  const handleAspectChange = (newAspect) => {
    if (newAspect !== aspect) {
      setAspect(newAspect);
      if (imgRef.current) {
        const { width, height } = imgRef.current;
        setCrop(centerAspectCrop(width, height, newAspect));
      }
    } else {
      setAspect(undefined);
    }
  };

  const isCropValid = useCallback(() => {
    if (!completedCrop?.width || !completedCrop?.height) return false;

    const pixelWidth = imgRef.current
      ? completedCrop.width * (imgRef.current.naturalWidth / 100)
      : 0;
    const pixelHeight = imgRef.current
      ? completedCrop.height * (imgRef.current.naturalHeight / 100)
      : 0;

    if (aspect) {
      return pixelWidth >= MIN_DIMENSION && pixelHeight >= MIN_DIMENSION;
    }

    const MIN_FREE_CROP = 100;
    return pixelWidth >= MIN_FREE_CROP && pixelHeight >= MIN_FREE_CROP;
  }, [completedCrop, aspect]);

  const handleSaveCrop = useCallback(async () => {
    if (!imgRef.current || !completedCrop) return;

    const canvas = document.createElement("canvas");
    const image = imgRef.current;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = completedCrop.width * scaleX;
    canvas.height = completedCrop.height * scaleY;

    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      completedCrop.x * scaleX,
      completedCrop.y * scaleY,
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
      0,
      0,
      canvas.width,
      canvas.height
    );

    const base64Image = canvas.toDataURL("image/jpeg", 1.0);

    canvas.toBlob(
      (blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        setProduct((prev) => ({
          ...prev,
          image: base64Image,
        }));
        setImagePreview(base64Image);
        setShowPreviewModal(false);
        setIsResolutionCorrect(true);
      },
      "image/jpeg",
      1
    );
  }, [completedCrop]);

  useEffect(() => {
    if (
      completedCrop?.width &&
      completedCrop?.height &&
      imgRef.current &&
      previewCanvasRef.current
    ) {
      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;

      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext("2d");

      const pixelRatio = window.devicePixelRatio;

      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;

      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
    }
  }, [completedCrop]);

  return (
    <>
      <style>{adornedStyles}</style>
      <Container className="vendor-product-form">
        <Row className="justify-content-md-center">
          <Col md={12}>
            <Card className="create-product-card-adorned">
              <div className="create-product-header-adorned">
                <div className="d-flex align-items-center">
                  <MdAddCircle size={36} style={{ marginRight: "16px" }} />
                  <div>
                    <h2 style={{ margin: 0, fontSize: "28px", fontWeight: "700", fontFamily: "'Inter', sans-serif" }}>
                      Create Restaurant Product
                    </h2>
                    <p style={{ margin: 0, opacity: 0.9, fontSize: "14px" }}>Add a new product to your menu</p>
                  </div>
                </div>
              </div>
              <Card.Body className="create-product-body-adorned">
                <Form onSubmit={handleSubmit}>
                  <HeadOfficeProductNote gate={gate} />
                {/* Vendor team permissions. Creating a product is catalogue:edit. */}
                {!gate.canCatalogue && (
                  <Alert variant="warning" className="mb-3">
                    Your role does not allow creating products. The form is read-only.
                  </Alert>
                )}

                  <Form.Group className="mb-4">
                    <Form.Label className="form-label-adorned">Product Image</Form.Label>
                    <div className="d-flex">
                      <Card className="image-upload-card-adorned" style={{ width: "18rem" }}>
                        <Card.Body
                          className="d-flex flex-column align-items-center justify-content-center"
                          style={{ minHeight: "200px" }}
                        >
                          {product.image ? (
                            <img
                              src={product.image}
                              alt="Product"
                              style={{ maxHeight: "200px", maxWidth: "100%" }}
                            />
                          ) : (
                            <Card.Text>
                              <Button
                                as="label"
                                className="btn-adorned-primary d-flex align-items-center justify-content-center"
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              >
                                <MdAddAPhoto size={24} className="me-2" />
                                Add Image
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg, .png, .jpeg"
                                  onChange={handleImageChange}
                                  id="file-input"
                                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                />
                              </Button>
                            </Card.Text>
                          )}
                        </Card.Body>
                      </Card>
                      <div className="ms-3">
                        <Form.Text className="text-muted">
                          <p style={{ marginBottom: "0" }}>
                            <strong>File requirements: </strong>
                          </p>
                          <p style={{ fontStyle: "italic", fontSize: "11px" }}>
                            {productPhotoHint()}
                          </p>
                          {/* The artwork template for this slot, when one is configured. */}
                          <ArtworkTemplateLink slotKey="restaurant.productCover" variant="inline" />
                          <MobileProductShootPicker
                            vendorId={ownerId}
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                            onSelectImage={(imageUrl) => {
                              setProduct((prev) => ({ ...prev, image: imageUrl }));
                              setImagePreview(imageUrl);
                              setUploadError(null);
                            }}
                          />
                          <AdditionalImagesStrip
                            value={product.additionalImages}
                            onChange={(next) =>
                              setProduct((prev) => ({
                                ...prev,
                                additionalImages: next,
                              }))
                            }
                            disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                          />
                          {product.image && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-start",
                              }}
                            >
                              <Button
                                variant="link"
                                as="label"
                                style={{
                                  color: "green",
                                  textDecoration: "none",
                                  textTransform: "capitalize",
                                  fontSize: "12px",
                                }}
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              >
                                Replace Image
                                <Form.Control
                                  type="file"
                                  hidden
                                  accept=".jpg, .png, .jpeg"
                                  onChange={handleImageChange}
                                  id="file-input"
                                  disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                />
                              </Button>
                              <span
                                style={{
                                  borderLeft: "1px solid #ccc",
                                  height: "30px",
                                }}
                              ></span>
                              <Button
                                variant="link"
                                style={{
                                  color: "red",
                                  textDecoration: "none",
                                  fontSize: "12px",
                                }}
                                onClick={() =>
                                  setProduct({ ...product, image: null })
                                }
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                              >
                                Remove Image
                              </Button>
                            </div>
                          )}

                          {/* Background Removal Section */}
                          {product.image && (
                            <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #e9ecef" }}>
                              <p style={{ marginBottom: "8px", fontWeight: "600", color: "#17385aff", fontSize: "13px" }}>
                                <MdAutoFixHigh size={16} style={{ marginRight: "4px", verticalAlign: "middle" }} />
                                Background Removal
                              </p>
                              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                <Button
                                  className="btn-adorned-primary"
                                  size="sm"
                                  onClick={handleRemoveBackground}
                                  disabled={removingBackground || submitting}
                                  style={{ fontSize: "12px", padding: "6px 12px" }}
                                >
                                  {removingBackground ? (
                                    <>
                                      <Spinner animation="border" size="sm" style={{ marginRight: "4px" }} />
                                      Removing...
                                    </>
                                  ) : (
                                    <>
                                      <MdAutoFixHigh size={14} style={{ marginRight: "4px" }} />
                                      Remove Background
                                    </>
                                  )}
                                </Button>

                                {backgroundRemoved && originalImage && (
                                  <Button
                                    className="btn-adorned-secondary"
                                    size="sm"
                                    onClick={handleRestoreOriginal}
                                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                    style={{ fontSize: "12px", padding: "6px 12px" }}
                                  >
                                    <MdUndo size={14} style={{ marginRight: "4px" }} />
                                    Restore Original
                                  </Button>
                                )}
                              </div>
                              {backgroundRemoved && (
                                <Alert variant="success" style={{ marginTop: "8px", fontSize: "12px", padding: "8px" }}>
                                  ✓ Background removed successfully!
                                </Alert>
                              )}
                              <p style={{ fontSize: "11px", color: "#6c757d", marginTop: "8px", fontStyle: "italic" }}>
                                Powered by Remove.bg - Automatically removes image backgrounds
                              </p>
                            </div>
                          )}
                        </Form.Text>
                      </div>
                    </div>
                  </Form.Group>

                  <ProductVideoSection
                    videos={product.videos || []}
                    onChange={(next) =>
                      setProduct((prev) => ({ ...prev, videos: next }))
                    }
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  />

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      value={product.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Product name..."
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      className="form-control-adorned"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Description (optional)</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="description"
                      value={product.description}
                      onChange={handleInputChange}
                      style={{ height: "100px" }}
                      placeholder="Enter a brief description of the product..."
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      className="form-control-adorned"
                    />
                  </Form.Group>

                  <WorkingRestaurantField
                    restaurant={workingRestaurant}
                    loading={workingRestaurantLoading}
                    labelClassName="form-label-adorned"
                  />

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Section</Form.Label>
                    <AppSelect block
                      name="section"
                      value={product.section}
                      onChange={handleInputChange}
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      className="form-control-adorned"
                    >
                      <option>Choose...</option>
                      {sections.map((section) => (
                        <option key={section._id} value={section._id}>
                          {section.title}
                        </option>
                      ))}
                    </AppSelect>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Price</Form.Label>
                    <Form.Control
                      type="number"
                      name="price"
                      value={product.price}
                      onChange={handleInputChange}
                      required
                      disabled={gate.lockPricing} title={gate.pricingTitle}
                      className="form-control-adorned"
                    />
                    {priceWarning && (
                      <Alert variant="danger">
                        <MdWarning size={24} className="me-2" />
                        {priceWarning}
                      </Alert>
                    )}
                    {selectedRestaurant && previewGrossPrice >= 0 && (
                      <Alert variant="info" className="mt-2 mb-0">
                        {selectedRestaurant.commissionConfigured ? "Contract" : "Fallback (needs commercial review)"} {previewCommissionRate}% · Lusuku commission UGX {previewCommission.toLocaleString()} · Restaurant net UGX {previewVendorNet.toLocaleString()}
                      </Alert>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Customer payment requirement</Form.Label>
                    <AppSelect block
                      name="requiredPaymentMethod"
                      value={product.requiredPaymentMethod}
                      onChange={handleInputChange}
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      className="form-control-adorned"
                    >
                      <option value="NONE">Any method (Cash on Delivery allowed)</option>
                      <option value="ANY_ONLINE">Pay before acceptance (any online method)</option>
                      <option value="MOMO">MTN Mobile Money only</option>
                      <option value="AIRTEL">Airtel Money only</option>
                      <option value="VISA">Card only</option>
                      <option value="ZAMTEL">Zamtel Kwacha only</option>
                    </AppSelect>
                    <Form.Text className="text-muted">
                      If prepayment is required, the kitchen cannot accept or prepare the order until payment is confirmed.
                    </Form.Text>
                  </Form.Group>
                  {/* Vendor discount: the list price above stays; the sale price is derived on read. */}
                  <DiscountFields
                    disabled={gate.lockPricing}
                    title={gate.pricingTitle}
                    value={product.discount}
                    onChange={(next) => setProduct((prev) => ({ ...prev, discount: next }))}
                    listPrice={product.price}
                  />

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Count in Stock</Form.Label>
                    <Form.Control
                      type="number"
                      name="countInStock"
                      value={product.countInStock}
                      onChange={handleInputChange}
                      required
                      min="1"
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      className="form-control-adorned"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Daily plate limit</Form.Label>
                    <Form.Control
                      type="number"
                      name="dailyLimit"
                      value={product.dailyLimit ?? ""}
                      onChange={handleInputChange}
                      min="1"
                      step="1"
                      placeholder="Leave empty for no daily limit"
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      className="form-control-adorned"
                    />
                    <Form.Text className="text-muted">
                      Plates per day. When that many have been ordered on any channel the dish
                      shows as sold out for today and returns tomorrow.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">
                      SEO Tags{" "}
                      <small className="text-muted" style={{ fontWeight: "normal", fontSize: "11px" }}>
                        — helps search engines find this product. Press Enter or comma to add.
                      </small>
                    </Form.Label>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: 6, padding: "6px 10px", border: "1px solid #ced4da", borderRadius: 4, minHeight: 40, background: "#fff", cursor: "text" }}
                      onClick={(e) => e.currentTarget.querySelector("input")?.focus()}>
                      {(product.tags || []).map((tag, i) => (
                        <span key={i} style={{ display: "inline-flex", alignItems: "center", background: "#e8f4fd", color: "#1a56db", borderRadius: 12, padding: "2px 10px", fontSize: 12, fontWeight: 600, gap: 4 }}>
                          {tag}
                          <span
                            onClick={() => setProduct(prev => ({ ...prev, tags: (prev.tags || []).filter((_, idx) => idx !== i) }))}
                            style={{ cursor: "pointer", marginLeft: 2, fontWeight: 700, color: "#888" }}>×</span>
                        </span>
                      ))}
                      <input
                        type="text"
                        placeholder={(product.tags || []).length === 0 ? `e.g. ${product.name ? product.name.split(" ")[0].toLowerCase() : "burger"}, spicy, fast-food` : ""}
                        style={{ border: "none", outline: "none", fontSize: 13, minWidth: 140, flex: 1 }}
                        disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === ",") {
                            e.preventDefault();
                            const val = e.target.value.trim().replace(/,$/, "");
                            if (val && !(product.tags || []).includes(val)) {
                              setProduct(prev => ({ ...prev, tags: [...(prev.tags || []), val] }));
                            }
                            e.target.value = "";
                          }
                        }}
                        onBlur={(e) => {
                          const val = e.target.value.trim();
                          if (val && !(product.tags || []).includes(val)) {
                            setProduct(prev => ({ ...prev, tags: [...(prev.tags || []), val] }));
                            e.target.value = "";
                          }
                        }}
                      />
                    </div>
                    <Form.Text className="text-muted" style={{ fontSize: 11 }}>
                      If left empty, the product name will be used automatically as the SEO tag.
                    </Form.Text>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="form-label-adorned">Option Groups</Form.Label>
                    <Select
                      isMulti
                      options={optionGroups.map((optionGroup) => ({
                        value: optionGroup._id,
                        label: `${optionGroup.name} (Min: ${optionGroup.minOptions}, Max: ${optionGroup.maxOptions})`,
                      }))}
                      value={selectedOptionGroups}
                      onChange={setSelectedOptionGroups}
                      placeholder="Select option groups..."
                      isDisabled={gate.lockCatalogue}
                    />
                    {selectedOptionGroups.length > 0 ? (
                      <div className="mt-2">
                        {selectedOptionGroups.map((chip) => {
                          const g = (optionGroups || []).find(
                            (x) => String(x._id) === String(chip.value)
                          );
                          if (!g) return null;
                          const max = Number(g.maxOptions);
                          const rule =
                            max === 1 ? "pick one" : max > 1 ? `up to ${max}` : "any number";
                          return (
                            <div
                              key={chip.value}
                              className="d-flex align-items-center justify-content-between py-1"
                              style={{ borderBottom: "1px solid #eef2f6", fontSize: 13 }}
                            >
                              <span>
                                <strong>{g.name}</strong>
                                <span className="text-muted">
                                  {" "}
                                  {Number(g.minOptions) > 0 ? "required" : "optional"}, {rule},{" "}
                                  {(g.options || []).length} option{(g.options || []).length === 1 ? "" : "s"}
                                </span>
                              </span>
                              <Button
                                variant="link"
                                size="sm"
                                className="p-0"
                                onClick={() => openEditGroup(chip.value)}
                                disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                                style={{ color: "#17385aff", fontWeight: "600", textDecoration: "none" }}
                              >
                                Edit
                              </Button>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                    <Button
                      variant="link"
                      onClick={openCreateGroup}
                      disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                      style={{ color: "#17385aff", fontWeight: "600", textDecoration: "none" }}
                    >
                      + Create New Option Group
                    </Button>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <FormControlLabel
                      control={
                        <Switch
                          checked={product.enabled}
                          onChange={(e) =>
                            setProduct({ ...product, enabled: e.target.checked })
                          }
                          name="enabled"
                          color="secondary"
                          disabled={gate.lockActivation} title={gate.activationTitle}
                        />
                      }
                      label={
                        product.enabled
                          ? "Activate Product For Customers"
                          : "Deactivate Product For Customers"
                      }
                      classes={{ label: classes.label }}
                    />
                    <Form.Text className="text-muted">
                      New products start deactivated so they can be checked before customers see them. Turn this on only if this one has already been checked.
                    </Form.Text>
                  </Form.Group>

                  <Button
                    className="btn-adorned-secondary"
                    onClick={() => setShowConfirmModal(true)}
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                    style={{ marginRight: "10px" }}
                  >
                    Discard changes
                  </Button>
                  <Button
                    className="btn-adorned-primary"
                    type="submit"
                    disabled={gate.lockCatalogue} title={gate.catalogueTitle}
                  >
                    {uploading ? (
                      <>
                        <Spinner animation="border" size="sm" /> Saving...
                      </>
                    ) : (
                      "Save changes"
                    )}
                  </Button>
                </Form>
                {uploading && (
                  <UploadProgress percent={uploadProgress} label="Uploading image" />
                )}
              </Card.Body>
            </Card>

            {/* Image preview Modal */}
            <Modal
              show={showPreviewModal}
              onHide={() => setShowPreviewModal(false)}
              size="lg"
              centered
              className="modal-adorned"
            >
              <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center justify-content-between w-100">
                  <span>Crop and Preview Image</span>
                  <div className="d-flex gap-2">
                    <Tooltip title="Free Crop">
                      <IconButton
                        size="small"
                        onClick={() => handleAspectChange(undefined)}
                        style={{
                          backgroundColor: !aspect
                            ? "rgba(25, 118, 210, 0.12)"
                            : "transparent",
                          color: !aspect ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                        }}
                      >
                        <MdCrop size={20} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Square (1:1)">
                      <IconButton
                        size="small"
                        onClick={() => handleAspectChange(1)}
                        style={{
                          backgroundColor:
                            aspect === 1
                              ? "rgba(25, 118, 210, 0.12)"
                              : "transparent",
                          color: aspect === 1 ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                        }}
                      >
                        <MdCropSquare size={20} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Landscape (16:9)">
                      <IconButton
                        size="small"
                        onClick={() => handleAspectChange(16 / 9)}
                        style={{
                          backgroundColor:
                            aspect === 16 / 9
                              ? "rgba(25, 118, 210, 0.12)"
                              : "transparent",
                          color:
                            aspect === 16 / 9 ? "#1976d2" : "rgba(0, 0, 0, 0.54)",
                        }}
                      >
                        <MdCropLandscape size={20} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex">
                  <div
                    className="flex-grow-1"
                    style={{
                      maxHeight: "70vh",
                      overflow: "auto",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      padding: "16px",
                    }}
                  >
                    {imagePreview && (
                      <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                        onComplete={(c) => setCompletedCrop(c)}
                        aspect={aspect}
                        minWidth={aspect ? MIN_DIMENSION : undefined}
                        minHeight={aspect ? MIN_DIMENSION : undefined}
                      >
                        <img
                          ref={imgRef}
                          alt="Crop me"
                          src={imagePreview}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "70vh",
                            objectFit: "contain",
                          }}
                          onLoad={handleImageLoad}
                        />
                      </ReactCrop>
                    )}
                  </div>
                  <div
                    className="ms-3"
                    style={{
                      width: "280px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                  >
                    <h6>Preview</h6>
                    <div
                      style={{
                        width: "100%",
                        aspectRatio: "1",
                        overflow: "hidden",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                      }}
                    >
                      <canvas
                        ref={previewCanvasRef}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    </div>
                    <div className="mt-2">
                      <Form.Text className="text-muted">
                        <strong>Image Requirements:</strong>
                        <ul style={{ fontSize: "12px", marginTop: "8px" }}>
                          <li>
                            Format: JPG or PNG
                            {isFormatCorrect ? (
                              <span className="text-success"> ✔</span>
                            ) : (
                              <span className="text-danger"> ✘</span>
                            )}
                          </li>
                          <li>
                            Size: ≤ 10MB
                            {isSizeCorrect ? (
                              <span className="text-success"> ✔</span>
                            ) : (
                              <span className="text-danger"> ✘</span>
                            )}
                          </li>
                          <li>
                            Dimensions: ≥ 1000x1000px
                            {completedCrop &&
                              completedCrop.width >= MIN_DIMENSION &&
                              completedCrop.height >= MIN_DIMENSION ? (
                              <span className="text-success"> ✔</span>
                            ) : (
                              <span className="text-danger"> ✘</span>
                            )}
                          </li>
                        </ul>
                      </Form.Text>
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="btn-adorned-secondary"
                  onClick={() => {
                    setShowPreviewModal(false);
                    setCrop({
                      unit: "%",
                      x: 0,
                      y: 0,
                      width: 90,
                      height: 90,
                    });
                    setCompletedCrop(null);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className="btn-adorned-primary"
                  onClick={handleSaveCrop}
                  disabled={!isCropValid()}
                >
                  Save Cropped Image
                </Button>
              </Modal.Footer>
            </Modal>
          </Col>
        </Row>

        {/* Modal for confirmation of product creation cancelation */}
        <Modal show={showConfirmModal} onHide={handleCloseDiscardModal} className="modal-adorned">
          <Modal.Header closeButton>
            <Modal.Title>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "1.5rem",
                }}
              >
                <MdWarning
                  size="30px"
                  color="orange"
                  style={{ marginRight: "10px" }}
                />
                You might have unsaved changes!
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>If you leave this page you will lose the changes you made.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-adorned-secondary"
              onClick={handleCloseDiscardModal}
              disabled={submitting}
            >
              Go back
            </Button>
            <Button
              className="btn-adorned-secondary"
              onClick={handleDiscardChanges}
              disabled={submitting}
            >
              Discard changes
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal for creating a new option group */}
        {/* <OptionGroupForm
                show={showOptionGroupModal}
                handleClose={() => setShowOptionGroupModal(false)}
                handleSave={handleOptionGroupSave}
                vendorId={vendorId} // Pass vendorId to OptionGroupForm
            /> */}
        {/* One editor for create and edit. The old RestaurantOptionGroupForm
            navigated to /admin/menu on save, throwing this half-typed dish
            away, and never called handleSave. */}
        <OptionGroupModal
          show={showOptionGroupModal}
          onClose={closeOptionGroupModal}
          ownerId={ownerId}
          group={editingGroup}
          onSaved={handleOptionGroupSave}
        />

        <style>
          {`
                    button.btn-outline-success {
                        border-color: #28a745;
                        color: #28a745;
                    }
                    
                    button.btn-outline-success:hover {
                        background-color: rgba(40, 167, 69, 0.08);
                        border-color: #28a745;
                        color: #28a745;
                        transform: translateY(-1px);
                    }
                    
                    button.btn-outline-danger {
                        border-color: #dc3545;
                        color: #dc3545;
                    }
                    
                    button.btn-outline-danger:hover {
                        background-color: rgba(220, 53, 69, 0.08);
                        border-color: #dc3545;
                        color: #dc3545;
                        transform: translateY(-1px);
                    }

                    .MuiIconButton-root {
                        transition: all 0.2s ease-in-out;
                    }
                    
                    .MuiIconButton-root:hover {
                        transform: scale(1.1);
                    }

                    .image-action-button {
                        border-radius: 20px;
                        padding: 6px 16px;
                        font-size: 0.875rem;
                        text-transform: none;
                        font-weight: 500;
                        transition: all 0.2s ease-in-out;
                        display: flex;
                        align-items: center;
                    }

                    .image-action-button:hover {
                        transform: translateY(-1px);
                    }
                `}
        </style>
      </Container>
    </>
  );
};

export default CreateRestaurantProductForm;
